<template>
<div ref="ShowSetting">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">小程序设置</span>
    </div>
    <div class="wechat">

        <!-- 手机模型 -->
        <div class="wechat-show">
            <div class="phone-out">
                <i class="icon-style1"></i>
                <i class="icon-style2"></i>
                <i class="icon-style3"></i>
                <div class="phone-out-in">
                    <span class="phone-out-in-close" v-if="!wechatisopen">小程序应用已关闭</span>
                    <div class="phone-in-content">
                        <i class="icon-style4"></i>
                        <div class="phone-in-main">
                            <div class="phoneContent">

                                <!-- 头部手机控件 -->
                                <div class="phone-wechat-header">
                                    <div class="phone-wechat-header-in">
                                        <i class="phone-wechat-header-icon1"></i>
                                        <i class="phone-wechat-header-icon1"></i>
                                        <i class="phone-wechat-header-icon1"></i>
                                        <i class="phone-wechat-header-icon1"></i>
                                        <i class="phone-wechat-header-icon1"></i>
                                        <i class="phone-wechat-header-icon2">WeChat</i>
                                        <i class="phone-wechat-header-icon3"></i>
                                        <i class="phone-wechat-header-icon4">22:32</i>
                                        <i class="phone-wechat-header-icon5">100%</i>
                                        <i class="phone-wechat-header-icon6"></i>
                                    </div>
                                </div>
                                <!-- 小程序头部 -->
                                <div class="phone-wechat-xcx-header">
                                    <div class="phone-wechat-xcx-header-in">
                                        <span><i class="xcx-icon1"></i><i class="xcx-icon2"></i></span>
                                    </div>
                                </div>

                                
                                <!-- 内容控件 -->
                                <div class="phone-wechat-content">

                                    <!-- banner图 -->
                                    <div class="phone-wechat-banner" v-show="param.banner.isshow" @click="SettingSelect('banner')" ref="banner">
                                        <i :class="param.banner.issselect ? 'component-normal compoent-select' : 'component-normal' "><el-image :src="require('@/assets/icon/position.png')" /></i>
                                        <el-carousel height="100px" autoplay="true">
                                            <el-carousel-item v-for="(item,index) in param.bannerinfodata" :key="index" v-show="item.isshow==1">
                                                <el-image :src="item.thumb" fit="cover" />
                                            </el-carousel-item>
                                        </el-carousel>
                                    </div>

                                    <!-- 问诊 -->
                                    <div class="phone-wechat-wx-shop top10" v-show="param.navicard.isshow" @click="SettingSelect('navicard')" ref="navicard">
                                        <i :class="param.navicard.issselect ? 'component-normal compoent-select' : 'component-normal' "><el-image :src="require('@/assets/icon/position.png')" /></i>
                                        <div class="phone-wechat-wx-shop-info" v-for="(t,i) in param.navicarddata" :key="i" v-show="t.isshow==1">
                                            <el-image :src="t.thumb" fit="cover" />
                                        </div>
                                    </div>

                                    <!-- 分类 -->
                                    <div class="phone-wechat-wx-cate top10"  v-show="param.catelist.isshow" @click="SettingSelect('catelist')" ref="catelist">
                                        <i :class="param.catelist.issselect ? 'component-normal compoent-select' : 'component-normal' "><el-image :src="require('@/assets/icon/position.png')" /></i>
                                        <div class="phone-wechat-wx-cate-info" v-for="(t,i) in param.catelistdata" :key="i" v-show="t.isshow==1">
                                            <div class="phone-wechat-wx-cate-in">
                                                <el-image :src="t.thumb" />
                                                <span>{{t.typename}}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 添加会员宠物 -->
                                    <div class="phone-wechat-wx-pet top10" v-show="param.addpet.isshow" @click="SettingSelect('addpet')" ref="addpet">
                                        <i :class="param.addpet.issselect ? 'component-normal compoent-select' : 'component-normal' "><el-image :src="require('@/assets/icon/position.png')" /></i>
                                        <div class="phone-wechat-wx-pet-title">
                                            <span class="phone-wechat-wx-pet-title-name">我家爱宠</span>
                                            <div class="phone-wechat-wx-pet-add-pet">添加宠物</div>
                                        </div>
                                        <div class="phone-wechat-wx-pet-content">
                                            <div class="phone-wechat-wx-pet-content-label">建立档案，精准养宠</div>
                                        </div>
                                    </div>

                                    <!-- 爱宠计划 -->
                                    <div class="phone-wechat-wx-pan top10" v-show="param.petplan.isshow" @click="SettingSelect('petplan')" ref="petplan">
                                        <i :class="param.petplan.issselect ? 'component-normal compoent-select' : 'component-normal' "><el-image :src="require('@/assets/icon/position.png')" /></i>
                                        <div class="phone-wechat-wx-pet-title">
                                            <span class="phone-wechat-wx-pet-title-name">爱宠计划</span>
                                            <div class="phone-wechat-wx-pet-add-pet">计划管理</div>
                                        </div>
                                        <div class="phone-wechat-wx-pet-time">
                                            <div class="phone-wechat-wx-pet-time-info is-active">今天</div>
                                            <div class="phone-wechat-wx-pet-time-info">7</div>
                                            <div class="phone-wechat-wx-pet-time-info">8</div>
                                            <div class="phone-wechat-wx-pet-time-info">9</div>
                                            <div class="phone-wechat-wx-pet-time-info">10</div>
                                            <div class="phone-wechat-wx-pet-time-info">更多</div>
                                        </div>
                                        <div class="phone-wechat-wx-pet-list">
                                            <div class="phone-wechat-wx-pet-list-info">
                                                <i></i>
                                                <span>称体重</span>
                                                <h>距离上一次称体重很久了，每月记录，进行健康检测</h>
                                            </div>
                                            <div class="phone-wechat-wx-pet-list-info">
                                                <i></i>
                                                <span>称内驱虫</span>
                                                <h>距离上一次驱虫已经很久了，定期驱虫，预防寄生虫</h>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                                <!-- 底部控件 -->
                                <div class="phone-wechat-footer" @click="SettingSelect('footer')" ref="footer">
                                    <i :class="param.footer.issselect ? 'component-normal compoent-select' : 'component-normal' "><el-image :src="require('@/assets/icon/position.png')" /></i>
                                    <div class="phone-wecaht-footer-info" v-for="(t,i) in param.footerdata" :key="i" v-show="t.isshow==1">
                                        <div class="phone-wecaht-footer-info-in">
                                            <el-image :src="t.thumb" />
                                            <span>{{t.typename}}</span>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>

        <!-- 手机设置 -->
        <div class="wechat-setting">
            <div class="wechat-setting-nav">
            <div class="TTL-button"><el-button @click="GetNavSetting('banner')" :type="settingparam.banner.activeshow ? '' : 'del' ">banner</el-button></div>
            <div class="TTL-button"><el-button @click="GetNavSetting('navicard')" :type="settingparam.navicard.activeshow ? '' : 'del'">广告</el-button></div>
            <div class="TTL-button"><el-button @click="GetNavSetting('catelist')" :type="settingparam.catelist.activeshow ? '' : 'del'">分类</el-button></div>
            <div class="TTL-button"><el-button @click="GetNavSetting('addpet')" :type="settingparam.addpet.activeshow ? '' : 'del'">新增宠物</el-button></div>
            <div class="TTL-button"><el-button @click="GetNavSetting('petplan')" :type="settingparam.petplan.activeshow ? '' : 'del'">宠物设置</el-button></div>
            <div class="TTL-button"><el-button @click="GetNavSetting('footer')" :type="settingparam.footer.activeshow ? '' : 'del'">底部设置</el-button></div>
            </div>
            <div class="TTL-show-or-close">
                <span class="TTL-show-or-close-title">{{wechatisopen ? '小程序已开启' : '小程序已关闭'}}</span>
                <div class="TTL-button"><el-button @click="GoSetting" :type="wechatisopen ? 'del' : ''" >{{wechatisopen ? '去关闭' : '去开启'}}</el-button></div>
            </div>
            <div class="wechat-setting-content top30">
                <banner :value="settingparam.banner.view" v-if="settingparam.banner.view" @finish="finishchild" />       
                <ad :value="settingparam.navicard.view" v-if="settingparam.navicard.view" @finish="finishchild" />       
                <catelist :value="settingparam.catelist.view" v-if="settingparam.catelist.view" @finish="finishchild" />
                <addpet :value="settingparam.addpet.view" v-if="settingparam.addpet.view" @finish="finishchild" />      
                <petplan :value="settingparam.petplan.view" v-if="settingparam.petplan.view" @finish="finishchild" />    
                <footers :value="settingparam.footer.view" v-if="settingparam.footer.view" @finish="finishchild" />     
            </div>
        </div>
    </div>
</div>
</template>


<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_WECHAT from '@/Interface/Shop/wechat';
import INTERFACE_SETTING from '@/Interface/Shop/setting';
import banner from '@/views/Setting/Module/banner';
import ad from '@/views/Setting/Module/ad';
import catelist from '@/views/Setting/Module/catelist';
import addpet from '@/views/Setting/Module/addpet';
import petplan from '@/views/Setting/Module/petplan';
import footers from '@/views/Setting/Module/footers';
export default {
    components: {banner,ad,catelist,addpet,petplan,footers},
    data() {
        return {
           param: {
                banner: { //banner
                   issselect:false,
                   isshow:true,
                },
                bannerinfodata:[],
                navicard: { //金刚为卡片
                   issselect:false,
                   isshow:true,
                },
                navicarddata:[],
                catelist: { //分类
                   issselect:false,
                   isshow:true,
                },
                catelistdata:[],
                addpet: { //新增宠物
                   issselect:false,
                   isshow:true,
                },
                addpetdata:[],
                petplan: { //爱宠计划
                   issselect:false,
                   isshow:true,
                },
                petplandata:[],
                footer: { //底部操作
                   issselect:false,
                   isshow:true,
                },
                footerdata:[],
           },

           settingparam: {
               banner: {activeshow:false,view:false},
               navicard: {activeshow:false,view:false},
               catelist: {activeshow:false,view:false},
               addpet: {activeshow:false,view:false},
               petplan: {activeshow:false,view:false},
               footer: {activeshow:false,view:false}
           },

           list: {
               banner: {isshow:false,list:[]},
               navicard: {isshow:false,list:[]},
               catelist: {isshow:false,list:[]},
               addpet: {isshow:false},
               petplan: {isshow:false},
               footer: {isshow:false,list:[]},
           },

           wechatisopen:false,

        }
    },

    mounted() {

        /** 页面数据初始化 **/
        this.OnloadMethod(); 
    },

    methods: {


        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.SettingSelect('banner'); //页面跳转到banner
            this.GetWechatSettingShow();  //获取小程序数据初始化设置
            this.GetSettingStatus();      //获取小程序是否开启或关闭
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.SettingSelect('banner'); //页面跳转到banner
                this.GetWechatSettingShow();  //获取小程序数据初始化设置
                this.GetSettingStatus();      //获取小程序是否开启或关闭
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }
        },


        /** 控件手机中自定义选择右边的banner**/
        SettingSelect(typename) {
            this.SettingSelectHandle(typename); //选中右边的导航
            this.GetNavSettingHandle(typename); //定位左边的手机控件
        },

        /** 点击右边的导航菜单 **/
        GetNavSetting(paramname) {
            this.SettingSelectHandle(paramname); //选中右边的导航
            this.GetNavSettingHandle(paramname); //定位左边的手机控件
        },


        /** 获取小程序数据初始化设置 **/
        GetWechatSettingShow() {
            INTERFACE_WECHAT.GET_SETTING_INFOS().then((res) => {
                if(res.status > 0) return false;
                this.list=res.data;

                //设置banner
                this.param.banner.isshow=this.list.banner.isshow;
                this.param.bannerinfodata=this.list.banner.list;

                //设置金刚区卡片
                this.param.navicard.isshow=this.list.navicard.isshow;
                this.param.navicarddata=this.list.navicard.list;

                //设置分类显示数据
                this.param.catelist.isshow=this.list.catelist.isshow;
                this.param.catelistdata=this.list.catelist.list;

                //设置新增宠物数据
                this.param.addpet.isshow=this.list.addpet.isshow;

                //设置爱宠计划数据
                this.param.petplan.isshow=this.list.petplan.isshow;

                //设置底部信息
                this.param.footer.isshow=this.list.footer.isshow;
                this.param.footerdata=this.list.footer.list;

            });
        },


        /** 子组件操作完结回调 **/
        finishchild() {
            this.GetWechatSettingShow();
        },


        /** 查看小程序是否开启/关闭 **/
        GetSettingStatus() {
            INTERFACE_SETTING.GET_WECHAT_IS_OPEN({name:'wechat_is_open'}).then((res) => {
                if(res.status > 0) return false;
                this.wechatisopen=res.data.wechat_is_open;
            });
        },

        //////////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////////
        //基础操作

        /** 控件手机中自定义选择右边的banner操作 **/
        SettingSelectHandle(typename) {
            for(var obj in this.settingparam) {
                this.settingparam[obj].activeshow=false;
                this.settingparam[obj].view=false;
            }
            this.settingparam[typename].activeshow=true;
            this.settingparam[typename].view=true;
        },

        /** 点击右边的导航菜单操作 **/
        GetNavSettingHandle(paramname) {
            var _this=this;
            //关闭选中区域
            for(var obj in this.param) this.param[obj].issselect=false;
            //选中指定位置区域
            this.param[paramname].issselect=true;
            //窗口滚动道指定位置
            this.$refs[paramname].scrollIntoView({behavior:'smooth',block:'center'});
            //延时关闭选中区域
            setTimeout(function() {_this.param[paramname].issselect=false;},2000);
        },


        /** 开启/关闭信息设置开关 **/
        GoSetting() {
            var navinfo={name:'系统设置',labelentry:'Setting',components:'Setting',isshow:false};
            var data={Method:'',name:'wechat_is_open',rollbackurl:'Wechat',rollbackname:'小程序设置'};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

        //////////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////////

    },

}
</script>
<style lang="scss" Scoped>
.TTL-form-submit-title {font-size:13px;letter-spacing: 1px;padding:20px 0;border-bottom:1px solid #F2F6FC;display:inline-block;width:100%;position: relative;}
.TTL-form-submit-title i {position: absolute;width:10px;height:40%;background-color: #666eeb;top:30%;border-radius: 6px;}
.wechat {display:inline-block;width:100%;}
.wechat-show {float:left;display:inline-flex;justify-content: center;width:calc(440px - 40px);padding:20px;}
.wechat-setting {float:left;display:inline-block;width:calc(100% - 440px - 40px) !important;padding:20px;}
.wechat-setting-content {display:inline-block;width:100%;}

.phone-out {width:300px;height:600px;background-color: #474747;border-radius:35px;display:inline-flex;justify-content: center;align-items: center;position: relative;box-shadow: 10px 10px 20px #909399;}
.icon-style1 {width:100px;height:10px;background-color:#1b191c;border-radius: 5px;position:absolute;top:0;left:0;margin-left:100px;margin-top:3px;border-bottom:1px solid #909399;z-index:1;}
.icon-style2 {width:5px;height:100px;background-color: #474747;border-radius: 0 10px 10px 0;position:absolute;top:0;right:0;margin-right:-5px;margin-top:70px;border-left:1px solid #909399;}
.icon-style3 {width:5px;height:50px;background-color: #474747;border-radius: 0 10px 10px 0;position:absolute;top:0;right:0;margin-right:-5px;margin-top:200px;border-left:1px solid #909399;}
.phone-out-in {width:285px;height:585px;background-color: #1b191c;border-radius: 35px;position: relative;display:inline-flex;justify-content: center;align-items: center;}
.phone-out-in-close {position:absolute;width:100%;height:100%;z-index:18;top:0;left:0;background-color: rgba(0,0,0,.8);border-radius: 35px;display: inline-flex;justify-content: center;align-items: center;font-size:13px;color:#ffffff;letter-spacing: 1px;}
.phone-in-content {width:275px;height:570px;background-color: #F5F7FA;border-radius: 40px;position:relative;overflow: hidden;overflow-x:auto;overflow-y: auto;}
.phone-in-main {width:100%;height:100%;overflow: hidden;overflow-x:auto;overflow-y: auto;}
.phone-in-main::-webkit-scrollbar{width:0;}

.phoneContent {width:100%;padding-bottom:60px;}
.icon-style4 {width:20px;height:20px;border-radius: 50%;background-color:#474747;position:absolute;z-index:1;top:0;left:0;margin-top:12px;margin-left:15px;}
.phone-wechat-header {width:100%;height:30px;display:block;font-size:0;position:absolute;top:0;background-color: #ffffff;z-index:15;}
.phone-wechat-header-in {display:inline-flex;align-items: center;width:100%;height:100%;}
.phone-wechat-header-icon1 {width:6px;height:6px;border-radius: 50%;background-color:#474747;margin-left:3px;}
.phone-wechat-header-icon2 {font-size:12px;margin-left:3px;font-style: normal;font-weight: 350;}
.phone-wechat-header-icon3 {width:15px;height:15px;background-image:url(@/assets/icon/wifi.png);background-repeat: no-repeat;background-size: 15px;background-position: center;margin-left:3px;}
.phone-wechat-header-icon4 {font-size:12px;position:absolute;width:100%;text-align: center;font-style:normal;font-weight: 400;}
.phone-wechat-header-icon5 {font-size:12px;font-style: normal;font-weight: 400;position:absolute;width:calc(100% - 50px);text-align: right;}
.phone-wechat-header-icon6 {height:20px;position:absolute;width:calc(100% - 20px);background-image:url(@/assets/icon/dianliang.png);background-repeat: no-repeat;background-size: 25px;background-position: right center;}

.phone-wechat-xcx-header {width:100%;height:40px;display:block;font-size:0;position:absolute;top:30px;background-color: #ffffff;z-index:15;}
.phone-wechat-xcx-header-in {width:100%;height:40px;display:inline-flex;align-items: center;justify-content: flex-end;}
.phone-wechat-xcx-header-in span {width:80px;height:25px;margin-right:10px;border:1px solid #E6E8EB;border-radius: 15px;display:inline-flex;align-items: center;position: relative;}
.xcx-icon1 {position:absolute;width:20px;height:20px;margin-left:10px;background-image:url(@/assets/icon/xcx-icon1.png);background-repeat: no-repeat;background-size:20px;background-position: center;}
.xcx-icon2 {position:absolute;width:15px;height:15px;margin-left:10px;background-image:url(@/assets/icon/xcx-icon2.png);background-repeat: no-repeat;background-size:15px;background-position: center;right:0;margin-right:10px;}

.phone-wechat-content {display:block;margin-top:70px;width:100%;background-color:#F5F7FA;}
.phone-wechat-banner {display:block;width:100%;height:100px;cursor: pointer;position:relative;}
.phone-wechat-banner .el-image {width:100%;height:100%;}
.phone-wechat-banner .el-carousel__button {width:10px;height:10px;border-radius: 50%;}
.phone-wechat-banner .el-carousel__button .is-active {background: #666eeb;}

.component-normal {display:none;}
.compoent-select {
    display:inline-flex;
    justify-content: center;
    align-items: center;
    position:absolute;
    width:100%;
    height:100%;
    top:0;
    left:0;
    background-color:rgba(0,0,0,.7);
    z-index:10;
}
.compoent-select .el-image {
    width:30px;
    height:30px;
}

.phone-wechat-wx-shop {display:inline-block;width:calc(100% - 20px);height:60px;padding:0 10px;position:relative;cursor: pointer;}
.phone-wechat-wx-shop-info {display:inline-block;width:calc((100% - 10px) / 2);height:60px;background-color: #ffffff;border-radius:6px;overflow:hidden;}
.phone-wechat-wx-shop-info:last-child {margin-left:10px;}
.phone-wechat-wx-shop-info .el-image {width:100%;height:100%;}

.phone-wechat-wx-cate {display:inline-block;width:calc(100% - 20px);padding:0 10px;position:relative;cursor: pointer;}
.phone-wechat-wx-cate-info {display:inline-flex;width:20%;float:left;justify-content: center;align-items: center;padding:5px 0;}
.phone-wechat-wx-cate-in {width:80%;margin:0 auto;text-align: center;}
.phone-wechat-wx-cate-in .el-image {width:70%;}
.phone-wechat-wx-cate-in span {display:inline-block;width:100%;text-align:center;overflow: hidden;overflow-x:auto;overflow-y: auto;font-size:12px;letter-spacing: 1px;margin-top:2px;color:#666666;}

.phone-wechat-wx-pet {display:inline-block;width:calc(100% - 40px);padding:10px;position:relative;cursor: pointer;margin-left:10px;border-radius:6px;background-color: #ffffff;}
.phone-wechat-wx-pet-title {display:inline-flex;width:100%;align-items: center;position:relative;}
.phone-wechat-wx-pet-title-name {font-size:14px;font-weight:550;color:#666666;letter-spacing: 1px;float:left;}
.phone-wechat-wx-pet-add-pet {font-size:12px;color:#999999;right:0;float:right;position:absolute;letter-spacing: 1px;}
.phone-wechat-wx-pet-content {
    position:relative;
    width:100%;
    height:100px;
    display:inline-block;
    border-radius: 6px;
    margin-top:10px;
    background-color: #effdf7;
    background-image:url(@/assets/avatar/cate/addpet-back.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: 0;
}
.phone-wechat-wx-pet-content-label {position:absolute;width:calc(100% - 20px);padding:5px 10px;border-radius: 6px;bottom:0;font-size:12px;letter-spacing: 1px;margin-bottom:-5px;background-color: #e5de95;}
.phone-wechat-wx-pan {display:inline-block;width:calc(100% - 40px);padding:10px;position:relative;cursor: pointer;margin-left:10px;border-radius:6px;background-color: #ffffff;}
.phone-wechat-wx-pet-time {display:inline-block;width:100%;padding:20px 0;}
.phone-wechat-wx-pet-time-info {display:inline-flex;width:calc(100% / 6);height:30px;font-size:12px;justify-content: center;align-items: center;text-align: center;border-radius: 6px;}
.phone-wechat-wx-pet-time .is-active {background-color: #73e0d0;color:#ffffff;}
.phone-wechat-wx-pet-list {display:inline-block;width:calc(100% - 10px);margin-left:5px;margin-top:10px;}
.phone-wechat-wx-pet-list-info {display:inline-block;width:calc(100% - 2px - 20px);padding:10px;border-left: 2px solid #73e0d0;position:relative;}
.phone-wechat-wx-pet-list-info i {width:10px;height:10px;background-color:#73e0d0;border-radius: 50%;position:absolute;left:0;top:0;margin-left:-5px;margin-top:-5px;box-shadow: 0 0 10px #73e0d0;}
.phone-wechat-wx-pet-list-info span {display: inline-block;width:100%;font-size:13px;line-height: 23px;color:#666666;}
.phone-wechat-wx-pet-list-info h {display: inline-block;width:100%;font-size:12px;line-height: 18px;color:#999999;}

.phone-wechat-footer {z-index:10;cursor: pointer;display: inline-flex;justify-content: center;align-items: center;position: absolute;width:100%;height:55px;bottom:0;background:#ffffff;box-shadow: 0 -1px 10px #E6E8EB;}
.phone-wecaht-footer-info {display:inline-flex;width:25%;height:100%;justify-content: center;align-items: center;}
.phone-wecaht-footer-info-in {display:block;width:80%;text-align: center;}
.phone-wecaht-footer-info .el-image {width:40%;display:block;margin:0 auto;}
.phone-wecaht-footer-info span {width:100%;color:#666666;font-size:12px;margin-top:2px;display:block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;letter-spacing: 2px;}

.wechat-setting-nav {display:inline-block;}
.wechat-setting-nav .TTL-button {display: inline-block;}
.wechat-setting-nav .TTL-button .el-button {border-radius: 0;border-right:none;}
.wechat-setting-nav .TTL-button:first-child .el-button {border-radius: 30px 0 0 30px;}
.wechat-setting-nav .TTL-button:last-child .el-button {border-radius: 0 30px 30px 0;border-right:1px solid #666eeb;}

.TTL-show-or-close {display: inline-flex;justify-content: center;align-items: center;height:45px;float:right;color:#666666;}
.TTL-show-or-close-title {font-size:13px;letter-spacing: 1px;margin-right:10px;}
</style>